import SelectDropdown from "../../../components/dropdown/selectdropdown/SelectDropdown"
import Heading from "../../../components/heading/Heading"
import { VEC_ICON_NAME } from "../../../components/icons/constants"
import { HEADING } from "../../../components/heading/constants/constants"
import commonStyles from "../../components/addpayernew/AddPayerCommonStyles.styles"
import styles from './PayerDropdown.styles'
import { useEffect, useState } from "react"
import { FILTER_OPTIONS } from "./constants"

export default function PayerDropdown({
    options = [],
    hideHeader = false,
    hideFilerOption = false,
    dropdownContainerStyles = {},
    containerStyles = {},

    selectPayerDropdownProps = {
        label: "",
        selectedValue: { label: '', value: '' },
        styles: {},
        onSearchInputChangeCb: () => { },
        onDropdownTouchedToBottomCb: () => { },
        clearSearchTextCb: () => { },
        onSelectCb: () => { },
    },
    disabled = false
}) {
    const [searchText, setSearchText] = useState("");
    const [filterOption, setFilterOption] = useState(FILTER_OPTIONS[0])

    useEffect(() => {
        if(searchText != "") {
            const timer = setTimeout(() => {
                if (selectPayerDropdownProps.onSearchInputChangeCb) {
                    selectPayerDropdownProps.onSearchInputChangeCb(searchText, filterOption)
                }
            }, 500);
    
            return () => {
                clearTimeout(timer);
            };
        }
        
    }, [searchText]);


    return (
        <>
            <div style={{ ...commonStyles.container, ...containerStyles }}>

                {!hideHeader && <div>
                    <Heading type={HEADING.H1}>Please select a payer</Heading>
                </div>}

                <div style={{ ...styles.selectGroupContainer, ...dropdownContainerStyles }}>

                    {!hideFilerOption && <SelectDropdown
                        value={filterOption}
                        onSelectCb={(name, selectedOption) => {
                            setFilterOption(selectedOption)
                            selectPayerDropdownProps.onSelectCb("selectPayer", { label: "", value: "" })
                        }}
                        options={FILTER_OPTIONS}
                        disabled={disabled}
                        isClearable={false}
                    />}

                    <SelectDropdown
                        label={selectPayerDropdownProps.label}
                        name="selectPayer"
                        customInputStyles={selectPayerDropdownProps.styles ? { ...selectPayerDropdownProps.styles } : {}}
                        placeHolder={filterOption?.value == "NAME" ? "Enter payers name" : "Enter payers tax id"}
                        suffixProps={{ icon: VEC_ICON_NAME.SEARCH_ICON }}
                        value={selectPayerDropdownProps.selectedValue}
                        onSelectCb={(name, selectedOption) => selectPayerDropdownProps.onSelectCb(name, selectedOption)}
                        options={options}
                        onDropdownTouchedToBottomCb={() => selectPayerDropdownProps.onDropdownTouchedToBottomCb()}
                        onSearchInputChangeCb={(e) => setSearchText(e.target.value)}
                        clearSearchTextCb={() => selectPayerDropdownProps.clearSearchTextCb && selectPayerDropdownProps.clearSearchTextCb()}
                        isClearable={false}
                        searchInitials={false}
                    />
                </div>
            </div>
        </>
    )
}